<!-- <div class="calculation-mobile-wrapper" fxLayout="row">
  <div class="calculation-mobile-container" fxLayout="column" fxFlex="" fxLayoutGap=".5em">
    <div class="order-title" fxLayout="row" fxLayoutAlign="space-between center">
      <h2>הזמנה {{data.general.shipmentTitle || 'חדשה'}}</h2>
      <span (click)="close()" style="font-size: 1.2em">X</span>
    </div>
    <app-share-order [order]="data.Order"></app-share-order> -->

<!--    <div class="order-actions" fxLayout="row" >-->
<!--      <button mat-icon-button matTooltip="גירסא להדפסה" (click)="SHARE('print')">-->
<!--        <mat-icon>print</mat-icon>-->
<!--      </button>-->
<!--      <button mat-icon-button matTooltip="שמור pdf" (click)="SHARE('savePdf')">-->
<!--        <mat-icon svgIcon="fi_pdf"></mat-icon>-->
<!--      </button>-->
<!--      <button mat-icon-button matTooltip="שתף בוואצאפ" (click)="SHARE('whatsapp')">-->
<!--        <mat-icon svgIcon="fi_whatsapp"></mat-icon>-->
<!--      </button>-->
<!--      <button mat-icon-button matTooltip="שתף במייל" (click)="SHARE('email')">-->
<!--        <mat-icon svgIcon="fi_email"></mat-icon>-->
<!--      </button>-->
<!--    </div>-->

<!-- <div class="order-shipment-details-container" fxLayout="column">
      <mat-card>
        <mat-card-title>פרטי הובלה</mat-card-title>
        <mat-card-subtitle>{{data.taxes.shipmentMethod.methodLabel}}</mat-card-subtitle>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">שיטת הובלה</span>
            <span class="val">{{data.sellingType}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">עלות ההובלה</span>
            <span class="val">{{data.shipmentOnlyIls|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-shipment-company-container" fxLayout="column">
      <mat-card>
        <mat-card-title>עלויות חברת הספנות</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">תוספת {{data.taxes.shipmentMethod.methodLabel}}</span>
            <span class="val">{{data.taxes.shipmentMethod.shipmentCompanyCosts|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-vehicle-details-container" fxLayout="column" fxFlex="">
      <mat-card>
        <mat-card-title>פרטי הרכב</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.vehicleType.label">
            <span class="key"> סוג שחרור</span>
            <span class="val">{{data.data.nameType}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.vehicleCurrency.name!=='ils'">
            <span class="key">מחיר הרכב</span>
            <span class="val">{{data.vehiclePrice|currency:data.vehicleCurrency.name.toUpperCase():'symbol'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">ערך הרכב בש"ח</span>
            <span class="val">{{data.vehiclePriceILS|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.vehicleType.label">
            <span class="key">סוג הרכב</span>
            <span class="val">{{data.vehicleType.label}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.vehiclePollution">
            <span class="key">דרגת זיהום אוויר</span> -->
<!--            <app-air-pollution-bar [airPollution]="data.vehiclePollution.rank"></app-air-pollution-bar>-->
<!-- <span class="val">{{data.vehiclePollution?.rank}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.greenScore">
            <span class="key">ציון ירוק:</span>
            <span class="val">{{data.greenScore}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.equipmentLevelSelected">
            <span class="key">רמת איבזור:</span>
            <span class="val">{{data.equipmentLevelSelected.rank}}</span>
            <fa-icon [icon]="faStar"></fa-icon>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-taxes-details-container" fxLayout="column" fxFlex="" *ngIf="data.transinsurance">
      <mat-card>
        <mat-card-title>ביטוח</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">ערך ביטוח להובלה </span>
            <span class="val">{{data.value2|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-taxes-details-container" fxLayout="column" fxFlex="">
      <mat-card>
        <mat-card-title>חישובי מיסים</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">ערך הרכב בש"ח</span>
            <span class="val">{{data.vehiclePriceILS|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">מיסי נמל לצורך חישוב מיסים</span>
            <span class="val">{{data.harborTaxes|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.transinsurance">
            <span class="key">ערך ביטוח למכס</span>
            <span class="val">{{data.insTransport|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="!data.transinsurance">
            <span class="key">ערך למכס</span>
            <span class="val">{{data.customClearancePrice|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.transinsurance">
            <span class="key">ערך למכס + ביטוח</span>
            <span class="val">{{data.insuranceValue|| 0|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">מכס</span>
            <span class="val">{{data.customClearanceVal|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.buyTax">
            <span class="key">מס קניה</span>
            <span class="val">{{data.taxes.buyTax|currency:'ILS'}}</span>
          </div>

          <div class="reductions-section" fxLayout="column" style="padding: 0.25em"
            *ngIf="data.taxes.reductions&&(data.taxes.reductions.green||data.taxes.reductions.type||data.taxes.reductions.equip)">
            <mat-card>
              <mat-card-title>הפחתות</mat-card-title>
              <mat-card-content fxLayout="column" fxLayoutGap=".5em">
                <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.reductions.type">
                  <span class="key">הפחתת הנעה</span>
                  <span class="val">{{data.taxes.reductions.type|currency:'ILS'}}</span>
                </div>
                <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.reductions.green">
                  <span class="key">הפחתת זיהום אוויר</span>
                  <span class="val">{{data.taxes.reductions.green|currency:'ILS'}}</span>
                </div>
                <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.reductions.equip">
                  <span class="key">הפחתת אבזור בטיחותי</span>
                  <span class="val">{{data.taxes.reductions.equip|currency:'ILS'}}</span>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.luxTax">
            <span class="key">מס יוקרה ({{data.taxes.luxTaxPercentage|percent}})</span>
            <span class="val">{{data.taxes.luxTax|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.finalTax">
            <span class="key">מס קניה מתואם</span>
            <span class="val">{{data.taxes.finalTax|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">מע"מ</span>
            <span class="val">{{data.taxes.vat|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card>
        <mat-card-title>תוספות</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">דמי ריקון + מיסי נמל</span>
            <span class="val">{{data.taxes.shipmentMethod.emptyPrice|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">עמילות מכס</span>
            <span class="val">{{data.taxes.customFee|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">דמי רשומון</span>
            <span class="val">{{data.taxes.registerFee|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-summery-details-container" fxLayout="column" fxFlex="">
      <mat-card>
        <mat-card-title>סיכום הזמנה</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap="1em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">סה"כ עלויות הובלה</span>
            <span class="val">{{data.taxes.shipmentOnly+
              data.taxes.shipmentMethod.shipmentCompanyCosts|currency:'ILS'}}</span>
          </div>
          <div *ngIf="data.transinsurance" class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">סה"כ עלויות ביטוח </span>
            <span class="val">{{data.taxes.value2|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">סה"כ מיסים + דמי רשימון</span>
            <span class="val">{{data.taxes.totalTaxes|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">מחיר מוערך לרכב</span>
            <span class="val">{{data.taxes.value|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div> -->

<div class="calculation-mobile-wrapper" fxLayout="row">
  <div class="calculation-mobile-container" fxLayout="column" fxFlex="" fxLayoutGap=".5em">
    <div class="order-title" fxLayout="row" fxLayoutAlign="space-between center">
      <h2>{{ 'CALC_SUMMARY.ORDER_TITLE' | translate }} {{data.general.shipmentTitle || ('CALC_SUMMARY.NEW' | translate)}}</h2>
      <span (click)="close()" style="font-size: 1.2em">X</span>
    </div>

    <app-share-order [order]="data.Order"
                     (saveOrderEvent)="saveOrder($event)">
    </app-share-order>
    <div class="order-shipment-details-container" fxLayout="column">
      <mat-card>
        <mat-card-title>{{ 'CALC_SUMMARY.SHIPPING_DETAILS' | translate }}</mat-card-title>
        <mat-card-subtitle>{{methodLabelDisplay(data.taxes.shipmentMethod)}}</mat-card-subtitle>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.SHIPPING_METHOD' | translate }}</span>
            <span class="val">{{data.sellingType}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.SHIPPING_COST' | translate }}</span>
            <span class="val">{{data.shipmentOnlyIls|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-shipment-company-container" fxLayout="column">
      <mat-card>
        <mat-card-title>{{ 'CALC_SUMMARY.SHIPPING_COMPANY_COSTS' | translate }}</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.SURCHARGE' | translate }} {{methodLabelDisplay(data.taxes.shipmentMethod)}}</span>
            <span class="val">{{data.taxes.shipmentMethod.shipmentCompanyCosts|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-vehicle-details-container" fxLayout="column" fxFlex="">
      <mat-card>
        <mat-card-title>{{ 'CALC_SUMMARY.VEHICLE_DETAILS' | translate }}</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.CLEARANCE_TYPE' | translate }}</span>
            <span class="val">{{data.nameType}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.vehicleCurrency.name!=='ils'">
            <span class="key">{{ 'CALC_SUMMARY.VEHICLE_PRICE' | translate }}</span>
            <span class="val">{{data.vehiclePrice|currency:data.vehicleCurrency.name.toUpperCase():'symbol'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.VEHICLE_VALUE_ILS' | translate }}</span>
            <span class="val">{{data.vehiclePriceILS|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.vehicleType.label">
            <span class="key">{{ 'CALC_SUMMARY.VEHICLE_TYPE' | translate }}</span>
            <span class="val">{{data.vehicleType.label}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.vehiclePollution">
            <span class="key">{{ 'CALC_SUMMARY.AIR_POLLUTION_LEVEL' | translate }}</span>
            <!--            <app-air-pollution-bar [airPollution]="data.vehiclePollution.rank"></app-air-pollution-bar>-->
            <span class="val">{{data.vehiclePollution?.rank}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.greenScore">
            <span class="key">{{ 'CALC_SUMMARY.GREEN_SCORE' | translate }}</span>
            <span class="val">{{data.greenScore}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.equipmentLevelSelected">
            <span class="key">{{ 'CALC_SUMMARY.EQUIPMENT_LEVEL' | translate }}</span>
            <span class="val">{{data.equipmentLevelSelected.rank}}</span>
            <!-- <fa-icon [icon]="faStar"></fa-icon> -->
          </div>
        </mat-card-content>
      </mat-card>
    </div>
   <div class="order-taxes-details-container" fxLayout="column" fxFlex="" *ngIf="data.transinsurance">
      <mat-card>
        <mat-card-title>{{ 'CALC_SUMMARY.INSURANCE' | translate }}</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.TRANSPORT_INSURANCE_VALUE' | translate }}</span>
            <span class="val">{{data.value2|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-taxes-details-container" fxLayout="column" fxFlex="">
      <mat-card>
        <mat-card-title>{{ 'CALC_SUMMARY.TAX_CALCULATIONS' | translate }}</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.VEHICLE_VALUE_ILS' | translate }}</span>
            <span class="val">{{data.vehiclePriceILS|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.HARBOR_TAXES_FOR_CALCULATION' | translate }}</span>
            <span class="val">{{data.harborTaxes|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.transinsurance">
            <span class="key">{{ 'CALC_SUMMARY.INSURANCE_VALUE_FOR_CUSTOMS' | translate }}</span>
            <span class="val">{{data.insTransport|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="!data.transinsurance">
            <span class="key">{{ 'CALC_SUMMARY.CUSTOMS_VALUE' | translate }}</span>
            <span class="val">{{data.customClearancePrice|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.transinsurance">
            <span class="key">{{ 'CALC_SUMMARY.CUSTOMS_VALUE_PLUS_INSURANCE' | translate }}</span>
            <span class="val">{{data.insuranceValue|| 0|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.CUSTOMS' | translate }}</span>
            <span class="val">{{data.customClearanceVal|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.buyTax">
            <span class="key">{{ 'CALC_SUMMARY.PURCHASE_TAX' | translate }}</span>
            <span class="val">{{data.taxes.buyTax|currency:'ILS'}}</span>
          </div>
          <div class="reductions-section" fxLayout="column" style="padding: 0.25em"
            *ngIf="data.taxes.reductions&&(data.taxes.reductions.green||data.taxes.reductions.type||data.taxes.reductions.equip)">
            <mat-card>
              <mat-card-title>{{ 'CALC_SUMMARY.REDUCTIONS' | translate }}</mat-card-title>
              <mat-card-content fxLayout="column" fxLayoutGap=".5em">
                <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.reductions.type">
                  <span class="key">{{ 'CALC_SUMMARY.DRIVE_REDUCTION' | translate }}</span>
                  <span class="val">{{data.taxes.reductions.type|currency:'ILS'}}</span>
                </div>
                <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.reductions.green">
                  <span class="key">{{ 'CALC_SUMMARY.AIR_POLLUTION_REDUCTION' | translate }}</span>
                  <span class="val">{{data.taxes.reductions.green|currency:'ILS'}}</span>
                </div>
                <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.reductions.equip">
                  <span class="key">{{ 'CALC_SUMMARY.SAFETY_EQUIPMENT_REDUCTION' | translate }}</span>
                  <span class="val">{{data.taxes.reductions.equip|currency:'ILS'}}</span>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.luxTax && data.vehicleWeight || data.taxes.luxTax && data.personalBroker">
            <span class="key">{{ 'CALC_SUMMARY.LUXURY_TAX' | translate }} ({{data.taxes.luxTaxPercentage|percent}})</span>
            <span class="val">{{data.taxes.luxTax|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.taxes.finalTax">
            <span class="key">{{ 'CALC_SUMMARY.ADJUSTED_PURCHASE_TAX' | translate }}</span>
            <span class="val">{{data.taxes.finalTax|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.VAT' | translate }}</span>
            <span class="val">{{data.taxes.vat|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
      <mat-card>
        <mat-card-title>{{ 'CALC_SUMMARY.ADDITIONS' | translate }}</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap=".5em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.EMPTYING_FEES_AND_HARBOR_TAXES' | translate }}</span>
            <span class="val">{{data.taxes.shipmentMethod.emptyPrice|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.CUSTOMS_BROKERAGE' | translate }}</span>
            <span class="val">{{data.taxes.customFee|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.REGISTRATION_FEE' | translate }}</span>
            <span class="val">{{data.taxes.registerFee|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="order-summery-details-container" fxLayout="column" fxFlex="">
      <mat-card>
        <mat-card-title>{{ 'CALC_SUMMARY.ORDER_SUMMARY' | translate }}</mat-card-title>
        <mat-card-content fxLayout="column" fxLayoutGap="1em">
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.TOTAL_TRANSPORT_COSTS' | translate }}</span>
            <span class="val">{{data.shipmentOnlyIls + data.taxes.shipmentMethod.shipmentCompanyCosts|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em" *ngIf="data.transinsurance">
            <span class="key">{{ 'CALC_SUMMARY.TOTAL_INSURANCE_COSTS' | translate }}</span>
            <span class="val">{{data.value2|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.TOTAL_TAXES_AND_REGISTRATION' | translate }}</span>
            <span class="val">{{data.taxes.totalTaxes|currency:'ILS'}}</span>
          </div>
          <div class="single-mobile-row" fxLayoutGap="1em">
            <span class="key">{{ 'CALC_SUMMARY.ESTIMATED_VEHICLE_PRICE' | translate }}</span>
            <span class="val">{{data.taxes.value|currency:'ILS'}}</span>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
